const ERROR = {
  SYSTEM_ERROR: "System error. Please try again later!",
};
const PATH = {
  //  AUTH PATHS
  // AUTH_LOGIN: "/",
  LOGIN: "/",
  DASHBOARD: "/dashboard",
  USER_DASHBOARD: "/my-team",
  USER: "/resources-settings",
  USER_PROFILE: "/resource-tasks",
  EDIT_USER: "edit-user",
  GENERATE_TEAM: "/create-team",
  BLOG_REQUEST: "/resources",
  VIEW_RESOURCES_TASKS: "/my-resources-tasks",
  USER_BLOG_REQUEST: "/user-blog-request",
  MY_BLOG: "/projects",
  NO_PAGE_FOUND: "*",
  RESOURCE_DASHBOARD: "/task-list",
  SALLERY_MANAGEMENT: "/sallery-management",
  RESOURCE_SALLERY_SETTINGS: "/sallery-settings",
  PROJECT_COST_ESTIMATION: "/projectCost-estimation",
  PROJECT_PROGRESS: "/project-progress",
  TEAM_LEAD_DASHBOARD: "/team-lead-dashboard",
};

export { ERROR, PATH };
